[].forEach.call(document.getElementsByClassName('accordion'), (a) => {
	a.getElementsByTagName('h2')[0].addEventListener('click', () => {
		document.body.focus();
		a.classList.toggle('open');
	});
});